import { useFormContext, useWatch, UseFormProps, UseFormReturn } from "react-hook-form";

import Linkify from 'linkify-react'

import { Box, Card, CardContent, Typography } from "@mui/material";
import Grid from '@mui/material/Unstable_Grid2'

import { TextInput } from "../components/TextInput";
import { SelectInput } from "../components/SelectInput";

interface IPrevFormProps {
  title: string
  schoolName3: string
  prevText?: string
}



export const PrevForm = (props: IPrevFormProps) => {

  const prevOptions = [
    { value: 1, title: `Já - í ${props.schoolName3} síðasta vetur` },
    { value: 2, title: `Já - áður í ${props.schoolName3}` },
    { value: 3, title: 'Já - nemandi hefur stundað nám annarsstaðar' },
    { value: 4, title: 'Nei - nemandi hefur ekki stundað tónlistarnám fyrr' }
  ]
  const prevTextOptions = [
    "",
    "",
    "Hvenær var það nám?",
    "Hvar og hvenær var það?",
    ""
  ]
  const form: UseFormReturn<IPrevFormProps, UseFormProps> = useFormContext();

  const textOption = useWatch({ name: 'prev' })
  
  // if (textOption < 2 || textOption > 3) {
  //   form.control.register('prevText', {value: " "})
  // }

  return (
    <Box sx={{ minWidth: 275, mt: 1 }}>
      <Card variant="outlined" sx={{ backgroundColor: '#EAF2F1', borderRadius: .6 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom sx={{ ml: 3 }}>{props.title}</Typography>
          <Grid container spacing={1}>

            <Grid xs={12} sm={12} md={5}>
              <SelectInput name="prev" label="Fyrra nám" options={prevOptions} />
            </Grid>

            {(textOption === 2 || textOption === 3) && <Grid xs={12} sm={12} md={7}>
              <TextInput multiline={true} maxRows={5} name="prevText" label={prevTextOptions[textOption]} />
            </Grid>}

          </Grid>
        </CardContent>
      </Card>
    </Box>
  )
}